import React, {Component} from 'react';
import './RightPanel.css';
import {ThreeBarsIcon, XIcon} from '@primer/octicons-react';

const textes = {
    'liste': {
        'fr': 'Liste des observateurs',
        'de': 'Liste der Beobachter',
        'it': 'Elenco di osservatori',
        'en': 'List of observers'
    },
    "observateur": {
        'fr': 'Observateur',
        'de': 'Beobachter',
        'it': 'Osservatore',
        'en': 'Observer'
    },
    "annee": {
        'fr': 'Année(s)',
        'de': 'Jahr(e)',
        'it': 'Anno/i',
        'en': 'Year(s)'
    },
    "remarque": {
        'fr': 'Remarque',
        'de': 'Anmerkung',
        'it': 'Annotazione',
        'en': 'Remark'
    },
    "commentaire": {
        'fr': 'Lorsque deux années sont affichées, il s\'agit de la première et la dernière.',
        'de': 'Werden zwei Jahreszahlen angezeigt, handelt es sich um das erste und das letzte gemeldete Beobachtungsjahr.',
        'it': 'Nel caso siano presenti due date, si tratta del primo e dell’ultimo anno d\'osservazione.',
        'en': 'When more than a year is shown, only first and last are shown.',
    },
    "masque": {
        'fr': '*masqué*',
        'de': '*maskiert*',
        'it': '*mascherato*',
        'en': '*hidden*',
    },
    "allochtone": {
        'fr': 'Allochtone',
        'de': 'allochthone',
        'it': 'alloctona',
        'en': 'allochthonous',
    }
};

class RightPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openClass: 'panel panel-close',
            iconClass: 'panel-icon',
            panelHidden: true,
            panelDisabled: true,
            pixel: props.pixel,
            nuesp: props.nuesp,
            data: [],
            isLoading: false,
            error: null,
            locale: props.locale
        };

        this.openPanel = this.openPanel.bind(this);
        this.closePanel = this.closePanel.bind(this);
    }

    openPanel(e) {
        this.setState({
            openClass: 'panel',
            panelHidden: !this.state.panelHidden
        })
    }

    closePanel(e) {
        this.setState({
            openClass: 'panel panel-close',
            panelHidden: !this.state.panelHidden
        })
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.nuesp !== nextProps.nuesp) {
            this.setState({
                nuesp: nextProps.nuesp,
                openClass: 'panel panel-close',
                panelHidden: true,
                panelDisabled: true
            });
        }

        if (this.props.locale !== nextProps.locale) {
            this.setState({
                locale: nextProps.locale
            });
        }

        if (this.props.pixel !== nextProps.pixel) {
            if (nextProps.pixel) {
                this.setState({
                    pixel: nextProps.pixel,
                    openClass: 'panel',
                    panelHidden: false,
                    panelDisabled: false,
                    data: []
                });

                fetch('https://lepus.infofauna.ch/carto-old/getpointinfo-json.php?x='
                    + nextProps.pixel[0] + '&y=' + nextProps.pixel[1] + '&nuesp=' + nextProps.nuesp)
                    .then(response => response.json())
                    .then(data =>
                        this.setState({
                            data: data,
                            isLoading: false,
                        })
                    )
                    .catch(error => this.setState({error, isLoading: false}));
            } else {
                this.setState({
                    pixel: null,
                    openClass: 'panel panel-close',
                    panelHidden: true,
                    panelDisabled: true,
                    data: []
                });
            }

        }

        return true;
    }

    setAutor(auteur) {
        return {
            __html: auteur.trim() !== '' ? auteur : textes.masque[this.state.locale]
        }
    }

    render() {
        return (
            <div className={this.state.openClass} disabled={this.state.panelDisabled}>
                <button onClick={this.openPanel} className="button-link panel-open-handle" hidden={!this.state.panelHidden}>
                    <ThreeBarsIcon size='medium' verticalAlign='middle' className={this.state.iconClass}/>
                    <h2 className="panel-title">{textes.liste[this.state.locale]}</h2>
                </button>
                <button hidden={this.state.panelHidden} onClick={this.closePanel} className="button-link panel-close-handle">
                    <XIcon size='medium' verticalAlign='middle' className="panel-icon"/>
                </button>
                <h2 hidden={this.state.panelHidden}>{textes.liste[this.state.locale]}</h2>
                <p>{textes.commentaire[this.state.locale]}</p>
                <table className="table table-white-font">
                    <thead>
                    <tr>
                        <th scope="col">{textes.observateur[this.state.locale]}</th>
                        <th scope="col">{textes.annee[this.state.locale]}</th>
                        <th scope="col">{textes.remarque[this.state.locale]}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.data.map(data => {
                            const {id, mx, mn, auteur, valid} = data;
                            return (
                                <tr key={id}>
                                    <td dangerouslySetInnerHTML={this.setAutor(auteur)}/>
                                    <td>{(mx === mn) ? mx : mn + ' / ' + mx}</td>
                                    <td>{valid === 51 ? textes.allochtone[this.state.locale] : '-'}</td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }

}

export default RightPanel;
